<template>
  <v-select
    ref="cselect"
    v-bind="$attrs"
    :attach="attach"
    :menu-props="{ nudgeBottom: 10, offsetY: true, maxHeight: menuMaxHeight }"
    :hide-details="showErrorsWithTooltip ? true : hideDetails"
    :data-cy="dataCy ? dataCy : false"
    v-on="$listeners"
    @update:error="setErrorsBucket">
    <template v-if="'chips' in $attrs" #selection="{ item, parent }">
      <v-chip
        :input-value="item"
        color="primary"
        outlined
        close
        @click:close="parent.selectItem(item)">
        {{ item[$attrs['item-text'] || 'title'] || item }}
      </v-chip>
    </template>

    <template v-else-if="$scopedSlots['selection']" #selection>
      <slot name="selection"></slot>
    </template>

    <template #message="{ message }">
      {{ parseError(message) }}
    </template>

    <template v-if="$scopedSlots['item']" #item="{ item }">
      <slot name="item" :item="item"></slot>
    </template>

    <template #append>
      <v-tooltip v-if="showErrorsWithTooltip && errorsList" color="red" bottom>
        <template #activator="{ on }">
          <v-icon color="red" class="v-icon--circle error-icon-tooltip" v-on="on">$warning</v-icon>
        </template>
        {{ errorsList }}
      </v-tooltip>
      <slot v-else name="append"></slot>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'CSelect',
  inheritAttrs: false,
  props: {
    attach: {
      type: [Boolean, String, Object],
      default: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    showErrorsWithTooltip: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: [Boolean, String],
      default: false,
    },
    dataCy: {
      type: [String, Boolean],
      default: '',
    },
    menuMaxHeight: {
      type: String,
      default: 'none',
    },
  },
  data() {
    return {
      errorBucket: [],
    };
  },
  computed: {
    errorsList() {
      if (this.errorMessage) {
        return this.errorMessage;
      }

      return this.errorBucket.join(',');
    },
  },
  mounted() {
    this.setErrorsBucket();
  },
  methods: {
    parseError(validationErr) {
      if (this.errorMessage) {
        return this.errorMessage;
      }

      try {
        const error = JSON.parse(validationErr);
        return this.$t(error.text, error.params);
      } catch (e) {
        return this.$t(validationErr);
      }
    },
    setErrorsBucket() {
      this.errorBucket = this.$refs.cselect.errorBucket.map(el => this.parseError(el));
    },
  },

};
</script>

<style lang="scss" scoped>
.error-icon-tooltip {
  position: absolute;
  top: 50%;
  right: -8px;
  transform: translateY(-50%);
}
</style>
